import { render, staticRenderFns } from "./ExpiringOffersSection.vue?vue&type=template&id=5e0b0df2&scoped=true"
import script from "./ExpiringOffersSection.vue?vue&type=script&lang=ts"
export * from "./ExpiringOffersSection.vue?vue&type=script&lang=ts"
import style0 from "./ExpiringOffersSection.vue?vue&type=style&index=0&id=5e0b0df2&prod&scoped=true&lang=css"
import style1 from "./ExpiringOffersSection.vue?vue&type=style&index=1&id=5e0b0df2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0b0df2",
  null
  
)

export default component.exports